import { store } from './../store'

export const PLAY_SOUND_BG  = 'PLAY_SOUND_BG'
export const STOP_SOUND_BG  = 'STOP_SOUND_BG'
export const PLAY_SOUND_MAIN  = 'PLAY_SOUND_MAIN'
export const PAUSE_SOUND_MAIN  = 'PAUSE_SOUND_MAIN'
export const RESUME_SOUND_MAIN  = 'RESUME_SOUND_MAIN'
export const USR_PAUSE_SOUND_MAIN  = 'USR_PAUSE_SOUND_MAIN'
export const USR_RESUME_SOUND_MAIN  = 'USR_RESUME_SOUND_MAIN'
export const SEEK_SOUND_MAIN  = 'SEEK_SOUND_MAIN'
export const STOP_SOUND_MAIN  = 'STOP_SOUND_MAIN'
export const END_SOUND_MAIN  = 'END_SOUND_MAIN'
export const PLAY_SOUND_MAIN_2  = 'PLAY_SOUND_MAIN_2'
export const STOP_SOUND_MAIN_2  = 'STOP_SOUND_MAIN_2'
export const PLAY_SOUND_OVERLAY  = 'PLAY_SOUND_OVERLAY'
export const STOP_SOUND_OVERLAY  = 'STOP_SOUND_OVERLAY'
export const PLAY_SOUND_AMBIENT  = 'PLAY_SOUND_AMBIENT'
export const STOP_SOUND_AMBIENT  = 'STOP_SOUND_AMBIENT'
export const VOLUME_UP_SOUND_AMBIENT  = 'VOLUME_UP_SOUND_AMBIENT'
export const VOLUME_DOWN_SOUND_AMBIENT  = 'VOLUME_DOWN_SOUND_AMBIENT'


export const playSoundBg = (path, params = {}) => {
  store.dispatch({type: PLAY_SOUND_BG, payload: {...params, path}})
}
export const playSoundMain = (path, params = {}) => {
  store.dispatch({type: PLAY_SOUND_MAIN, payload: {...params, path}})
}
export const playSoundMain2 = (path, params = {}) => {
  store.dispatch({type: PLAY_SOUND_MAIN_2, payload: {...params, path}})
}
// automatic pause
export const pauseSoundMain = () => {
  store.dispatch({type: PAUSE_SOUND_MAIN})
}
// auto resume
export const resumeSoundMain = () => {
  store.dispatch({type: RESUME_SOUND_MAIN})
}
// user hits pause audio
export const userPauseSoundMain = () => {
  store.dispatch({type: USR_PAUSE_SOUND_MAIN})
}
// user hits play audio
export const userResumeSoundMain = () => {
  store.dispatch({type: USR_RESUME_SOUND_MAIN})
}
export const seekSoundMain = (time) => {
  store.dispatch({type: SEEK_SOUND_MAIN, payload: time})
}
export const playSoundOverlay = (path, params = {}) => {
  store.dispatch({type: PLAY_SOUND_OVERLAY, payload: {...params, path}})
}
export const playSoundAmbient = (path, params = {}) => {
  store.dispatch({type: PLAY_SOUND_AMBIENT, payload: {...params, path}})
}
export const stopSoundBg = () => {
  store.dispatch({type: STOP_SOUND_BG})
}
export const stopSoundMain = () => {
  store.dispatch({type: STOP_SOUND_MAIN})
}
export const endSoundMain = (path) => {
  store.dispatch({type: END_SOUND_MAIN, payload: path})
}
export const stopSoundMain2 = () => {
  store.dispatch({type: STOP_SOUND_MAIN_2})
}
export const stopSoundOverlay = () => {
  store.dispatch({type: STOP_SOUND_OVERLAY})
}
export const stopSoundAmbient = () => {
  store.dispatch({type: STOP_SOUND_AMBIENT})
}
export const volumeUpSoundAmbient = () => {
  store.dispatch({type: VOLUME_UP_SOUND_AMBIENT})
}
export const volumeDownSoundAmbient = () => {
  store.dispatch({type: VOLUME_DOWN_SOUND_AMBIENT})
}

